import { WA_NUMBER } from './products'

export interface Offer {
  id: number
  name: string
  includes: string[] // products inside a combo; empty array for a single product
  originalPrice: number
  offerPrice: number
  savings: number
  image: string
  pain: string
  description: string
  benefits: string[]
  waMessage: string
}

export const offers: Offer[] = [
  {
    id: 1,
    name: 'Combo Fuerza + Masa',
    includes: [
      'Isolate Protein Mix 900g (Profit)',
      'Creatine POWER 300g (Profit)',
    ],
    originalPrice: 2290,
    offerPrice: 1390,
    savings: 900,
    image:
      'https://cdn.magicpatterns.com/uploads/g2gkabWXWwXzgMAADaGtf5/Isolate_protein_mix_y_creatine_powder.jpg',
    pain: 'El atleta que quiere ganar músculo y fuerza pero gasta de más comprando cada suplemento por separado.',
    description:
      'Proteína de alta calidad + creatina pura en un solo combo económico para crecer más rápido. La combinación perfecta para construir músculo y potenciar tu fuerza desde el primer mes.',
    benefits: [
      'Proteína de alta concentración por porción',
      'Creatina pura para más fuerza y potencia',
      'Ahorrás comprando ambos juntos',
      'Ideal para ganar masa muscular',
      'Recuperación muscular acelerada',
      'El combo más vendido para empezar',
    ],
    waMessage:
      'Hola! Quiero el Combo Fuerza + Masa — Isolate Protein Mix 900g + Creatine POWER 300g por $1.390 UY. ¿Tienen stock disponible?',
  },
  {
    id: 2,
    name: 'Combo Masa + Creatina',
    includes: [
      'Anabolic MASS 28500 3kg (Profit)',
      'Creatine POWER 300g (Profit)',
    ],
    originalPrice: 2590,
    offerPrice: 1590,
    savings: 1000,
    image:
      'https://cdn.magicpatterns.com/uploads/cmh1V2TfazNJ6qCDbNRVdm/Anabolic_Mass_3kg_2B_Creatine_POWER_300g.jpg',
    pain: 'Querés ganar masa muscular y potenciar tu fuerza pero comprar cada suplemento por separado se va de presupuesto.',
    description:
      'Hipercalórico de alta calidad + creatina potente para ganar volumen y fuerza en un solo combo accesible. El stack ideal para hardgainers que quieren resultados de verdad.',
    benefits: [
      'Hipercalórico con 28.500mg de activos',
      'Creatina potente para fuerza explosiva',
      'Superávit calórico controlado',
      'Ideal para ganar peso y volumen',
      '3kg de combustible puro',
      'Resultados visibles en pocas semanas',
    ],
    waMessage:
      'Hola! Quiero el Combo Masa + Creatina — Anabolic MASS 28500 3kg + Creatine POWER 300g por $1.590 UY. ¿Tienen stock disponible?',
  },
  {
    id: 3,
    name: 'Combo Definición Total',
    includes: [
      'Isolate Protein Mix 900g (Profit)',
      'Creatine POWER 300g (Profit)',
      'Pro Abdomen 60 Caps (Profit)',
    ],
    originalPrice: 2590,
    offerPrice: 1890,
    savings: 700,
    image:
      'https://cdn.magicpatterns.com/uploads/w4t68R7iTURZ63PtmY88qT/Isolate_2B_Creatine_2B_Pro_abdomen.jpg',
    pain: 'Querés definir tu físico, ganar fuerza y quemar grasa abdominal pero armar el stack completo te sale caro.',
    description:
      'Proteína + creatina + termogénico en un solo combo. Todo lo que necesitás para definir y rendir al máximo. El pack completo para los que quieren músculo marcado y bajo porcentaje de grasa.',
    benefits: [
      'Proteína de alta calidad para músculo',
      'Creatina para fuerza y rendimiento',
      'Termogénico para quemar grasa',
      'Favorece la definición abdominal',
      'Stack completo de definición',
      'Máximo aprovechamiento de tu entrenamiento',
    ],
    waMessage:
      'Hola! Quiero el Combo Definición Total — Isolate Protein Mix 900g + Creatine POWER 300g + Pro Abdomen 60 Caps por $1.890 UY. ¿Tienen stock disponible?',
  },
  {
    id: 4,
    name: 'Combo Power + Creatina Cibeles',
    includes: [
      'Power Whey Protein Isolate 2LB (Cibeles)',
      'Creatina CREAPURE Cibeles 150g (Cibeles)',
    ],
    originalPrice: 4690,
    offerPrice: 3590,
    savings: 1100,
    image:
      'https://cdn.magicpatterns.com/uploads/5yDWr8q9NmFtUK9yavoPhQ/Power_Whey_Protein_2LB_2B_Creatine_Creapure_150g.jpg',
    pain: 'Querés la proteína más pura del mercado con creatina certificada pero el precio individual te limita.',
    description:
      'Proteína Isolate premium + creatina CREAPURE en formato accesible. El combo élite para resultados serios. La combinación de máxima pureza y calidad certificada del mercado uruguayo.',
    benefits: [
      'Proteína Isolate de máxima pureza',
      'Creatina CREAPURE certificada mundialmente',
      'Absorción ultra rápida post-entreno',
      'Sin grasas ni lactosa añadida',
      'Calidad premium Cibeles',
      'El combo élite para atletas serios',
    ],
    waMessage:
      'Hola! Quiero el Combo Power + Creatina Cibeles — Power Whey Protein Isolate 2LB + Creatina CREAPURE 150g por $3.590 UY. ¿Tienen stock disponible?',
  },
  {
    id: 5,
    name: 'Pro Abdomen 60 Caps — Profit',
    includes: [],
    originalPrice: 990,
    offerPrice: 690,
    savings: 300,
    image:
      'https://cdn.magicpatterns.com/uploads/kAprmK88P6DQyeVRcH72oe/Pro_abdomen.jpg',
    pain: '¿Entrenás abdominales todos los días pero la grasa abdominal no se va? Por más ejercicio que hagas, sin el apoyo metabólico correcto, esa capa de grasa sigue tapando tu progreso.',
    description:
      'Pro Abdomen de Profit es un suplemento termogénico diseñado para potenciar la quema de grasa abdominal. Con ingredientes que aceleran el metabolismo y favorecen la definición, es el complemento perfecto para tu dieta y entrenamiento.',
    benefits: [
      'Potencia la quema de grasa localizada',
      'Acelera el metabolismo naturalmente',
      'Favorece la definición abdominal',
      'Complemento ideal para dieta y cardio',
      '60 cápsulas — fácil de tomar',
      'Resultados visibles con constancia',
    ],
    waMessage:
      'Hola! Quiero el Pro Abdomen 60 Caps en oferta por $690 UY. ¿Tienen stock disponible?',
  },
  {
    id: 6,
    name: 'Whey Protein Cibeles 4 LB',
    includes: [],
    originalPrice: 5480,
    offerPrice: 4190,
    savings: 1290,
    image:
      'https://cdn.magicpatterns.com/uploads/xjQLVWgkkVp9hcLxyfqdVt/Whey_Protein_Cibeles4lb.jpg',
    pain: 'Ya sabés lo que es la whey y la necesitás de forma consistente. Cada vez que se te acaba, perdés días sin suplementarte y eso afecta tu progreso semana a semana.',
    description:
      'Para el atleta que ya sabe que la proteína es no-negociable. 4 libras de whey protein CIBELES para mantener tu suplementación sin interrupciones, con el mejor costo por porción y la calidad que ya conocés y confiás.',
    benefits: [
      '4 LB para suplementación continua',
      'Mejor costo-beneficio por porción',
      'Proteína completa de alta absorción',
      'Para atletas de entrenamiento regular',
      'Sin cortes en tu suplementación',
      'Resultados sostenidos en el tiempo',
    ],
    waMessage:
      'Hola! Quiero el Whey Protein Cibeles 4 LB en oferta por $4.190 UY. ¿Tienen stock disponible?',
  },
  {
    id: 7,
    name: 'Anabolic MASS 28500 3kg — Profit',
    includes: [],
    originalPrice: 1860,
    offerPrice: 1290,
    savings: 570,
    image:
      'https://cdn.magicpatterns.com/uploads/3a2vVnSjXyQF7cG2wEnThv/Anabolic_Mass.jpg',
    pain: '¿Comés de todo y no subís ni un kilo? Tu metabolismo quema calorías más rápido de lo que las consumís. Sin un superávit calórico real, tu cuerpo no tiene material para construir músculo nuevo.',
    description:
      'Anabolic MASS 28500 de Profit es el hipercalórico más completo del mercado. Con 28.500mg de activos por porción, combina proteínas, carbohidratos complejos, creatina y glutamina en 3kg de puro combustible para ganar masa muscular de verdad.',
    benefits: [
      '28.500mg de activos por porción',
      'Proteínas + carbohidratos + creatina + glutamina',
      '3kg — máxima duración y rendimiento',
      'Ideal para hardgainers y ectomorfos',
      'Superávit calórico controlado y efectivo',
      'Ganancia de masa muscular comprobada',
    ],
    waMessage:
      'Hola! Quiero el Anabolic MASS 28500 3kg en oferta por $1.290 UY. ¿Tienen stock disponible?',
  },
  {
    id: 8,
    name: 'Power Whey Protein Isolate 4 LB',
    includes: [],
    originalPrice: 7230,
    offerPrice: 5590,
    savings: 1640,
    image:
      'https://cdn.magicpatterns.com/uploads/amhzhq63fgh5pkD7ND4mgW/Powerwheyprotein4lb.png',
    pain: "¿Estás cansado de quedarte sin proteína a mitad de mes y frenar tu progreso? O peor, comprás un bote pequeño más caro por porción porque 'ahorrás' inicialmente. El ciclo de escasez destruye tu continuidad.",
    description:
      'El bote grande para el atleta serio. 4 libras de la mejor whey protein de CIBELES garantizan tu suplementación por un período extendido sin interrupciones. Más por menos, más consistencia, más resultados. Para los que van en serio.',
    benefits: [
      '4 LB — máxima duración y ahorro',
      'Alta concentración proteica por porción',
      'Ideal para atletas de entrenamiento frecuente',
      'Mejor costo por porción del mercado',
      'Sostenés tu suplementación sin cortes',
      'Músculo constante = resultados constantes',
    ],
    waMessage:
      'Hola! Quiero el Power Whey Protein Isolate 4 LB en oferta por $5.590 UY. ¿Tienen stock disponible?',
  },
]
